import axios from "../axios";
import errorHandler from "../error-handler";

export const fetchCountyListStatus = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/status/counties`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const fetchMunicipalityListStatus = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/status/municipalities`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const fetchZipCodeListStatus = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/status/zip_codes`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const syncCountyList = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/sync/counties`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const syncMunicipalityList = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/sync/municipalities`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const syncZipCodeList = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/sync/zip_codes`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );
